<template>
  <v-container>
    <div>
      <v-btn @click="refresh">
        <span>Refresh</span>
        <v-icon right>mdi-reload</v-icon>
      </v-btn>
    </div>
    <Filters @refresh="(opts) => changeFilters(opts)" />
    <div>
      <EventTable
        :pipeline-events="pipelineEvents"
        :loading="eventsLoading"
        @open-event-dialog="openEventDialog"
        @open-retry-dialog="openRetryDialog"
      />
    </div>
    <v-dialog v-model="eventDialogOpen" scrollable max-width="900px">
      <EventDescription v-if="currentEvent" :pipeline-event="currentEvent" />
    </v-dialog>
    <v-dialog v-model="retryDialogOpen" scrollable fullscreen hide-overlay>
      <EventRetryDialog
        v-if="currentEvent"
        :pipeline-event="currentEvent"
        @close="closeRetryDialog"
        @retry="retryOrder"
        @ignore="ignoreOrder"
      ></EventRetryDialog>
    </v-dialog>
    <v-snackbar v-model="showSnackbar" :color="colorSnackbar">
      {{ textSnackbar }}
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import EventTable from "@/components/Pipeline/EventTable";
import EventDescription from "@/components/Pipeline/EventDescription";
import EventRetryDialog from "@/components/Pipeline/EventRetryDialog";
import Filters from "@/components/Pipeline/Filters";

export default {
  components: {
    EventTable,
    EventDescription,
    Filters,
    EventRetryDialog,
  },
  data() {
    return {
      eventsLoading: false,
      fetchInterval: null,
      expand: null,
      currentEvent: null,
      eventDialogOpen: false,
      retryDialogOpen: false,
      showSnackbar: false,
      colorSnackbar: "green",
      textSnackbar: "",
      pipelineEvents: [],
      options: {
        status: null,
        number: null,
        platform: null,
        platformOrderUuid: null,
        restaurantPlatformId: null,
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    changeFilters(options) {
      clearInterval(this.fetchInterval);
      this.options = options;
      this.refresh();
      this.fetchInterval = setInterval(() => {
        this.refresh();
      }, 20000);
    },
    ...mapActions("orders", {
      fetchPipelineEvents: "fetchPipelineEvents",
      getPipelineEvent: "getPipelineEvent",
      retryPipelineEvent: "retryPipelineEvent",
      ignorePipelineEvent: "ignorePipelineEvent",
    }),
    async refresh() {
      this.eventsLoading = true;
      let response = await this.fetchPipelineEvents(this.options);
      this.pipelineEvents = response.data;
      this.eventsLoading = false;
    },
    async openEventDialog(eventId) {
      let response = await this.getPipelineEvent(eventId);
      this.currentEvent = response.data;
      this.eventDialogOpen = true;
    },
    async openRetryDialog(eventId) {
      let response = await this.getPipelineEvent(eventId);
      this.currentEvent = response.data;
      this.retryDialogOpen = true;
    },
    async retryOrder(eventId, order, retryOptions, retryTarget, retryType) {
      let payload = {
        retryOptions,
        order,
        retryTarget,
        retryType,
      };
      try {
        await this.retryPipelineEvent({
          eventId,
          payload,
        });
        this.textSnackbar = "Retried Successfully";
        this.colorSnackbar = "green";
        this.showSnackbar = true;
      } catch (error) {
        this.textSnackbar = error;
        this.colorSnackbar = "red";
        this.showSnackbar = true;
      }
    },
    async ignoreOrder(eventId) {
      try {
        this.ignorePipelineEvent(eventId);
        this.textSnackbar = "Ignored successfully";
        this.colorSnackbar = "green";
        this.showSnackbar = true;
      } catch (error) {
        this.textSnackbar = error;
        this.colorSnackbar = "red";
        this.showSnackbar = true;
      }
    },
    closeRetryDialog() {
      this.retryDialogOpen = false;
      this.currentEvent = null;
    },
  },
  computed: {
    thisComp() {
      return this;
    },
  },
  mounted() {
    this.refresh();
    this.fetchInterval = setInterval(() => {
      this.refresh();
    }, 20000);
  },
  beforeRouteLeave(_, __, next) {
    clearInterval(this.fetchInterval);
    next();
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-menu__content {
  box-shadow: 10px 5px 5px red;
  position: absolute;
  left: auto !important;
  top: auto !important;
}
</style>
